enum SIGN_IN_BASIC_INFO {
  loginNextButton = 'loginNextButton',
}

export { SIGN_IN_BASIC_INFO };
